import { CartItemsProps } from './../models/cart-item';
import * as React from 'react'; 
import { ElCartItem } from "./cart-item";

export const ElCartItemsTable = (props: any) => {
    const jsx = props.items.map((item: any) =>
        <ElCartItem
            index={item.index}
            product={item.product}
            onDelete={() => props.onDelete(item.product)}
            onAmountChange={(number: number) => { console.log('event-', number); props.onItemAmountChange(number, item.product); }} />);
    return jsx;
}